import firebase from 'firebase/app'
import 'firebase/storage'

export const app = firebase.initializeApp({
    apiKey: "AIzaSyDW1VPk8tPFfkz_C0uzxaRn_ljx69kTeBU",
    authDomain: "ike-asistencia-aa45a.firebaseapp.com",
    databaseURL: "https://ike-asistencia-aa45a.firebaseio.com",
    projectId: "ike-asistencia-aa45a",
    storageBucket: "ike-asistencia-aa45a.appspot.com",
    messagingSenderId: "872242290994",
    appId: "1:872242290994:web:9404355ddb41c7f071772b",
    measurementId: "G-XB0Y007JD8"
});